export default class APIResponseError {
    constructor (json) {
        this._errors = json.errors
        this._errorMessage = json.displayErrorMessage
    }

    message () {
        // inconsistencies in error responses
        return this._errorMessage || this._errors[0].errorMessage
    }

    success () {
        return false
    }
}

// {
//     "errors": [
//         {
//             "errorCode": 704,
//             "errorMessage": "Email Already used for another account"
//         }
//     ],
//     "responseCode": "FAILURE",
//     "displayErrorMessage": "The email entered is already in use"
// }



// WEBPACK FOOTER //
// ./src/models/responses/APIResponseError.js